/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AddAdvancedFinancialEligibilityPatientHistoryMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  date: Types.Scalars['Date']['input']
  description: Types.Scalars['String']['input']
  costEstimate?: Types.InputMaybe<Types.FinancialEligibilityCostEstimateInput>
  insuranceSubscriber?: Types.InputMaybe<Types.FinancialEligibilityInsuranceSubscriberInput>
}>

export type AddAdvancedFinancialEligibilityPatientHistoryMutation = {
  __typename?: 'Mutation'
  addFinancialEligibilityPatientHistory:
    | { __typename?: 'CommonPatientHistory'; entryID: string }
    | { __typename?: 'FinancialEligibilityPatientHistory'; entryID: string }
    | { __typename?: 'LabOrderPatientHistory'; entryID: string }
    | { __typename?: 'VideoCallPatientHistory'; entryID: string }
}

export const AddAdvancedFinancialEligibilityPatientHistoryDocument = gql`
  mutation addAdvancedFinancialEligibilityPatientHistory(
    $uid: ID!
    $date: Date!
    $description: String!
    $costEstimate: FinancialEligibilityCostEstimateInput
    $insuranceSubscriber: FinancialEligibilityInsuranceSubscriberInput
  ) {
    addFinancialEligibilityPatientHistory(
      uid: $uid
      date: $date
      description: $description
      costEstimate: $costEstimate
      insuranceSubscriber: $insuranceSubscriber
    ) {
      entryID
    }
  }
`
export type AddAdvancedFinancialEligibilityPatientHistoryMutationFn = Apollo.MutationFunction<
  AddAdvancedFinancialEligibilityPatientHistoryMutation,
  AddAdvancedFinancialEligibilityPatientHistoryMutationVariables
>

/**
 * __useAddAdvancedFinancialEligibilityPatientHistoryMutation__
 *
 * To run a mutation, you first call `useAddAdvancedFinancialEligibilityPatientHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdvancedFinancialEligibilityPatientHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdvancedFinancialEligibilityPatientHistoryMutation, { data, loading, error }] = useAddAdvancedFinancialEligibilityPatientHistoryMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      date: // value for 'date'
 *      description: // value for 'description'
 *      costEstimate: // value for 'costEstimate'
 *      insuranceSubscriber: // value for 'insuranceSubscriber'
 *   },
 * });
 */
export function useAddAdvancedFinancialEligibilityPatientHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAdvancedFinancialEligibilityPatientHistoryMutation,
    AddAdvancedFinancialEligibilityPatientHistoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AddAdvancedFinancialEligibilityPatientHistoryMutation,
    AddAdvancedFinancialEligibilityPatientHistoryMutationVariables
  >(AddAdvancedFinancialEligibilityPatientHistoryDocument, options)
}
export type AddAdvancedFinancialEligibilityPatientHistoryMutationHookResult = ReturnType<
  typeof useAddAdvancedFinancialEligibilityPatientHistoryMutation
>
export type AddAdvancedFinancialEligibilityPatientHistoryMutationResult =
  Apollo.MutationResult<AddAdvancedFinancialEligibilityPatientHistoryMutation>
export type AddAdvancedFinancialEligibilityPatientHistoryMutationOptions = Apollo.BaseMutationOptions<
  AddAdvancedFinancialEligibilityPatientHistoryMutation,
  AddAdvancedFinancialEligibilityPatientHistoryMutationVariables
>
